<template>
  <div class="h-screen bg-white dark:bg-slate-800 flex flex-col max-h-screen md:w-1/3 lg:w-full lg:col-span-3 relative">
    
    <!-- En-tête -->
    <InfoUser />
    
    <!-- Barre de recherche -->
    <Search />
    
    <!-- Filtre -->
    <Filter />
    
    <!-- Liste des conversations -->
    <Conversations />

    <!-- FAB - Bouton flottant (Floating Action Button) -->
    <button
      @click="openNewConversationModal"
      type="button"
      class="group fixed bottom-6 right-6 lg:absolute w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 active:scale-90 z-40 flex items-center justify-center"
      title="Nouvelle conversation">
      <i class="las la-comment-medical text-2xl group-hover:scale-110 transition-transform"></i>
      
      <!-- Badge avec tooltip au hover -->
      <div class="absolute -top-12 right-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        <div class="bg-gray-900 dark:bg-gray-700 text-white text-sm px-3 py-2 rounded-lg shadow-lg whitespace-nowrap">
          Nouvelle conversation
          <div class="absolute bottom-0 right-4 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-4 border-t-gray-900 dark:border-t-gray-700 transform translate-y-full"></div>
        </div>
      </div>

      <!-- Effet de pulsation (optionnel) -->
      <span class="absolute inset-0 rounded-full bg-teal-400 opacity-75 animate-ping"></span>
    </button>

    <!-- Modal Nouvelle Conversation -->
    <NewConversationModal
      :is-open="isModalOpen"
      @close="closeModal"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Filter from './components/Filter.vue';
import InfoUser from './components/InfoUser.vue';
import Search from './components/Search.vue';
import Conversations from './components/Conversations.vue';
import NewConversationModal from './components/NewConversationModal.vue';

export default {
  name: "InboxIndex",
  components: {
    Conversations,
    Filter,
    InfoUser,
    Search,
    NewConversationModal
  },
  data() {
    return {
      isModalOpen: false
    }
  },
  computed: {
    ...mapFields("conversations/list", {
      isLoading: "isLoading",
      conversations: "items",
      isSuccess: "isSuccess",
      message: "message",
      showMessage: "showMessage",
      filterSearch: "filterSearch"
    }),
  },
  methods: {
    openNewConversationModal() {
      this.isModalOpen = true;
    },
    
    closeModal() {
      this.isModalOpen = false;
    },
    
    handleSuccess(data) {
      console.log('✅ Conversation créée avec succès:', data);
      // Afficher une notification toast ou autre feedback
    }
  }
}
</script>

<style scoped>
/* Animation de pulsation pour le FAB */
@keyframes ping {
  75%, 100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.animate-ping {
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
}
</style>
